<mbs-modal
  [title]="
    isFFI
      ? ('wizards:schedule_modal_title_ffi' | i18next: { format: 'title' })
      : isIncremental
        ? ('wizards:schedule_modal_title_incremental' | i18next: { format: 'title' })
        : ('wizards:schedule_modal_title_not_incremental' | i18next: { format: 'title' })
  ">
  <ng-container
    modal-body
    [formGroup]="form">
    <mbs-form-group class="mb-4">
      <div class="row align-items-start">
        <div class="col-4">
          <mbs-select
            formControlName="recurringPeriod"
            [appendTo]="'.modal-content'"
            [clearable]="false"
            [id]="'modal-recurring-period-select'"
            [items]="recurringPeriodItems"
            [label]="'wizards:recurring_period_type_label' | i18next"
            [searchable]="false"
            (change)="recurringPeriodChangeHandler($event)"></mbs-select>
        </div>
        <div
          *ngIf="form.get('recurringPeriod').value === 'Daily'"
          class="col-8">
          <div
            class="d-flex justify-content-between"
            formArrayName="weeklyDayOfWeek">
            <mbs-checkbox
              *ngFor="let day of daysOfWeekEnumArray; let i = index; let len = count"
              class="mt-0"
              [centerCheckbox]="true"
              [class.mr-3]="i !== len - 1"
              [formControlName]="i.toString()"
              [label]="getDayLabel(day.label)"
              [labelPosition]="'top'"></mbs-checkbox>
          </div>
        </div>
        <div
          *ngIf="!isIncremental && form.get('recurringPeriod').value === 'Monthly'"
          class="col-8">
          <div class="row">
            <div class="col-6">
              <mbs-select
                formControlName="occurrence"
                [appendTo]="'.modal-content'"
                [bindLabel]="'label'"
                [bindValue]="'value'"
                [clearable]="false"
                [id]="'modal-occurrence-select'"
                [items]="weekNumberEnumArray"
                [label]="'wizards:occurrence_label' | i18next"
                [searchable]="false"></mbs-select>
            </div>
            <div class="col-6">
              <mbs-number
                *ngIf="form.get('occurrence').value === -1"
                formControlName="dayOfMonthCount"
                [id]="'modal-day-of-month-count'"
                [label]="'wizards:day_label' | i18next"
                [max]="31"
                [min]="1"></mbs-number>
              <mbs-select
                *ngIf="form.get('occurrence').value !== -1"
                formControlName="dayOfWeek"
                [appendTo]="'.modal-content'"
                [bindLabel]="'label'"
                [bindValue]="'value'"
                [clearable]="false"
                [id]="'modal-day-of-week-select'"
                [items]="daysOfWeekEnumArray"
                [label]="'wizards:day_label' | i18next"
                [searchable]="false"></mbs-select>
            </div>
          </div>
        </div>
      </div>
    </mbs-form-group>

    <ng-container *ngIf="form.get('recurringPeriod').value === 'Daily'">
      <ng-container *ngIf="isIncremental">
        <mbs-form-group class="mb-0">
          <div class="row">
            <div class="col-4">
              <mbs-radio
                formControlName="dailyFreqPeriodOption"
                value="OccursAt"
                [descriptionOutside]="true"
                [id]="'modal-occurs-at-radio-1'"
                [label]="'wizards:occurs_at_label' | i18next"
                [name]="'modal-daily-period-option'"
                (change)="occursAtChangeHandler($event)">
                <ng-template radioDescription>
                  <div class="row">
                    <div class="col-12">
                      <mbs-timepicker
                        formControlName="occursAtTime"
                        [meridian]="true"
                        [needChangeInvalid]="true"></mbs-timepicker>
                    </div>
                  </div>
                </ng-template>
              </mbs-radio>
            </div>
            <div class="col-8">
              <mbs-radio
                formControlName="dailyFreqPeriodOption"
                value="OccursEvery"
                [descriptionOutside]="true"
                [id]="'modal-occurs-at-radio-2'"
                [label]="'wizards:occurs_every_label' | i18next"
                [name]="'modal-daily-period-option'"
                (change)="occursAtChangeHandler($event)">
                <ng-template radioDescription>
                  <mbs-form-group class="mb-2">
                    <div class="form-row">
                      <div class="col-4">
                        <mbs-number
                          formControlName="occursEveryCount"
                          [max]="form.get('occursEveryPeriod').value === 'hours' ? maxHours : maxMinutes"
                          [min]="1"></mbs-number>
                      </div>
                      <div class="col-5">
                        <mbs-select
                          formControlName="occursEveryPeriod"
                          [bindLabel]="'label'"
                          [bindValue]="'value'"
                          [clearable]="false"
                          [items]="hoursOrMinutesItems"
                          [searchable]="false"
                          (change)="occursEveryPeriodChangeHandler($event)"></mbs-select>
                      </div>
                    </div>
                  </mbs-form-group>

                  <mbs-form-group>
                    <div class="form-row">
                      <div class="col-6">
                        <mbs-timepicker
                          formControlName="occursEveryFromTime"
                          [id]="'modal-occurs-every-from-time'"
                          [label]="'wizards:big_from_label' | i18next"
                          [meridian]="true"
                          [needChangeInvalid]="true"></mbs-timepicker>
                      </div>
                      <div class="col-6">
                        <mbs-timepicker
                          formControlName="occursEveryToTime"
                          [id]="'modal-occurs-every-to-time'"
                          [label]="'wizards:big_to_label' | i18next"
                          [meridian]="true"
                          [needChangeInvalid]="true"></mbs-timepicker>
                      </div>
                    </div>
                  </mbs-form-group>
                </ng-template>
              </mbs-radio>
            </div>
          </div>
        </mbs-form-group>
      </ng-container>
    </ng-container>

    <mbs-form-group *ngIf="isIncremental && form.get('recurringPeriod').value === 'Monthly'">
      <div class="form-row">
        <div class="col-4">
          <mbs-select
            formControlName="occurrence"
            [appendTo]="'.modal-content'"
            [bindLabel]="'label'"
            [bindValue]="'value'"
            [clearable]="false"
            [id]="'modal-occurrence-select'"
            [items]="weekNumberEnumArray"
            [label]="'wizards:occurrence_label' | i18next"
            [searchable]="false"></mbs-select>
        </div>
        <div class="col-4">
          <mbs-number
            *ngIf="form.get('occurrence').value === -1"
            formControlName="dayOfMonthCount"
            [id]="'modal-day-of-month-count'"
            [label]="'wizards:day_label' | i18next"
            [max]="31"
            [min]="1"></mbs-number>
          <mbs-select
            *ngIf="form.get('occurrence').value !== -1"
            formControlName="dayOfWeek"
            [appendTo]="'.modal-content'"
            [bindLabel]="'label'"
            [bindValue]="'value'"
            [clearable]="false"
            [id]="'modal-day-of-week-select'"
            [items]="daysOfWeekEnumArray"
            [label]="'wizards:day_label' | i18next"
            [searchable]="false"></mbs-select>
        </div>
        <div class="col-4">
          <mbs-timepicker
            formControlName="occursAtTime"
            [label]="'wizards:occurs_at_label' | i18next"
            [meridian]="true"
            [needChangeInvalid]="true"></mbs-timepicker>
        </div>
      </div>
    </mbs-form-group>

    <mbs-form-group *ngIf="validVersionForSchedule && (!this.isUnix || form.get('recurringPeriod').value === 'Monthly')">
      <div class="form-row">
        <div class="col-4">
          <mbs-input-label [label]="'wizards:repeat_every_label' | i18next"></mbs-input-label>
          <div class="form-row align-items-center">
            <div class="col-6">
              <mbs-number
                formControlName="repeatEveryCount"
                [id]="'schedule-modal-repeat-every-count'"
                [max]="
                  form.get('recurringPeriod').value === 'Daily'
                    ? 31
                    : form.get('recurringPeriod').value === 'Weekly'
                      ? 52
                      : form.get('recurringPeriod').value === 'Monthly'
                        ? 12
                        : 99
                "
                [min]="1"></mbs-number>
            </div>
            <span class="col-auto">
              <label
                class="mbs-form_label mb-0"
                [for]="'schedule-modal-repeat-every-count'">
                {{ getCounterText() }}
              </label>
            </span>
          </div>
        </div>
        <div class="col-4">
          <mbs-datepicker
            formControlName="startFromDate"
            [label]="'wizards:start_from_label' | i18next"
            [needSetCurrent]="true"></mbs-datepicker>
        </div>
      </div>
    </mbs-form-group>

    <div
      *ngIf="!isIncremental"
      class="mbs-form-text">
      {{ 'wizards:not_incremental_inherited_text' | i18next: { occursAtTime: getFormatTime(form.get('occursAtTime').value) } }}
    </div>
  </ng-container>
  <ng-container modalFooter>
    <button
      class="btn btn-primary"
      type="button"
      (click)="saveClickHandler()">
      {{ 'shared:buttons.save' | i18next: { format: 'title' } }}
    </button>
    <button
      class="btn btn-secondary"
      data-dismiss="modal"
      type="button"
      (click)="cancelClickHandler()">
      {{ 'shared:buttons.cancel' | i18next: { format: 'title' } }}
    </button>
  </ng-container>
</mbs-modal>
